<template>
	<v-tabs
		v-model="localValue"
		show-arrows="never"
		hide-slider
		centered
		:optional="optional"
		center-active
		:active-class="activeClass"
		class="v-day-date"
	>
		<!-- :style="{ maxWidth: `${maxWidth}px`}" -->
		<v-tab
			v-for="day in selectedMonthDays"
			:key="day.date"
			class="d-flex flex-column"
			:tab-value="day.date"
			:disabled="(!day.isCurrentDay && disabled )"
		>
			<span class="v-day-date__name">{{day.shortName}}</span>
			<span
				class="v-day-date__number"
				:class="{ [activeTextClass]: day.isCurrentDay }"
			>{{$options.filters.formatNumber(day.dayNumber, 0)}}</span>
		</v-tab>
	</v-tabs>
</template>

<script>
import moment from 'moment';
export default {
	name: 'VMonthDays',

	props: {
		month: { type: String, default: new Date().toISOString().slice(0, 7) },
		optional: { type: Boolean, default: true },
		value: { type: String, default: () => moment().format('YYYY-MM-DD') },
		maxWidth: { type: Number },
		disabled: { type: Boolean, default: false },
		activeClass: { type: String, default: 'primary white--text' },
	},

	computed: {
		// selectedMonthDays() {
		// 	const days = [];
		// 	const currentMonth = moment(this.month, 'YYYY-MM');
		// 	const daysInMonth = currentMonth.daysInMonth();
		// 	const firstDayOfMonth = currentMonth.startOf('month').day();

		// 	const prevMonth = currentMonth.clone().subtract(1, 'month');
		// 	const daysInPrevMonth = prevMonth.daysInMonth();

		// 	for (let i = firstDayOfMonth; i > 0; i--) {
		// 		const day = daysInPrevMonth - i + 1;
		// 		const date = prevMonth.clone().date(day).format('YYYY-MM-DD');
		// 		days.push({
		// 			dayNumber: day.toString().padStart(2, '0'),
		// 			shortName: moment(date).format('dd'),
		// 			shortMonthName: moment(date).format('MMM'),
		// 			date,
		// 			isCurrentMonth: false
		// 		});
		// 	}

		// 	for (let i = 1; i <= daysInMonth; i++) {
		// 		const date = this.month + '-' + i.toString().padStart(2, '0');
		// 		days.push({
		// 			dayNumber: i.toString().padStart(2, '0'),
		// 			shortName: moment(date).format('dd'),
		// 			shortMonthName: moment(date).format('MMM'),
		// 			date,
		// 			isCurrentMonth: true
		// 		})
		// 	}

		// 	const nextMonth = currentMonth.clone().add(1, 'month');
		// 	const remainingDays = 42 - days.length;

		// 	for (let i = 1; i <= remainingDays; i++) {
		// 		const date = nextMonth.clone().date(i).format('YYYY-MM-DD');
		// 		days.push({
		// 			dayNumber: i.toString().padStart(2, '0'),
		// 			shortName: moment(date).format('dd'),
		// 			shortMonthName: moment(date).format('MMM'),
		// 			date,
		// 			isCurrentMonth: false
		// 		});
		// 	}

		// 	return days;
		// },
		selectedMonthDays() {
			const days = [];
			const baseMonth = moment(this.month, 'YYYY-MM');

			// Loop from 3 months before to 3 months after
			for (let i = -3; i <= 3; i++) {
				const targetMonth = baseMonth.clone().add(i, 'months');
				const daysInMonth = targetMonth.daysInMonth();

				// Loop through each day of the target month
				for (let day = 1; day <= daysInMonth; day++) {
					const date = targetMonth.clone().date(day).format('YYYY-MM-DD');
					days.push({
						dayNumber: day.toString().padStart(2, '0'),
						shortName: moment(date).format('dd'),
						shortMonthName: moment(date).format('MMM'),
						date,
						isCurrentMonth: i === 0,
						isCurrentDay: date === this.value
					});
				}
			}
			return days;
		},

		// دائرة الرقم تنقلب بيضاء عند التحديد، فيأخذ الرقم لون خلفية الشريحة نفسه
		activeTextClass() {
			return `${this.activeClass.split(' ')[0]}--text`;
		},

		localValue: {
			get() {
				return this.value;
			},
			set(newVal) {
				this.$emit('input', newVal);
				this.$emit('change', newVal);
			}
		}
	}
}
</script>

<style lang="scss">
/*
	شرائح الأيام: مستطيلات بيضاء بحدّ رقيق فوق أرضية الصفحة الرمادية،
	اسم اليوم باهت في الأعلى ورقمه أبرز في الأسفل، واليوم المحدّد مملوء بلون التطبيق.
	التنسيق هنا لا في الصفحات، ليتوحّد شكل الشريط في كل مكان يستخدم المكوّن -
	ولأن v-tabs يُستخدم أيضاً كأشرطة تبويب حقيقية في صفحات أخرى فلا يصحّ تعميمه عليها
*/
.v-day-date {
	// يعادل تخصيص قواعد Vuetify، فتُكرَّر سلسلة theme--light لتحسم الترجيح بلا !important
	&.theme--light.v-tabs > .v-tabs-bar {
		background-color: transparent;

		// Vuetify يبهت نص التبويب غير المحدّد، والرقم هنا يحتاج تبايناً كاملاً
		.v-tab:not(.v-tab--active) {
			color: rgba(0, 0, 0, 0.87);
		}
	}

	// الشريحة أطول منها عرضاً، وارتفاع الشريط هو ما يمدّد الشرائح في Vuetify
	.v-tabs-bar {
		height: 54px;
	}

	/*
		مع show-arrows="never" يُخفي Vuetify السهمين، لكنه يُبقي مكان السهم السابق
		محجوزاً بعرض 52px على الجوال عند فيض الشرائح، فيبدو الشريط مزاحاً عن أول الصفحة
	*/
	.v-slide-group__prev,
	.v-slide-group__next {
		flex: 0 0 0;
		min-width: 0;
		overflow: hidden;
	}

	.v-tab {
		background-color: #fff;
		border: var(--app-border);
		border-radius: 18px;
		margin: 0 4px;
		min-width: 30px;
		padding: 0 3px;
		// افتراضات v-tab نصّية (أحرف كبيرة وتباعد) لا تناسب حرف اليوم ورقمه
		text-transform: none;
		letter-spacing: normal;
	}

	// طبقة التموّج المربّعة تتجاوز الحواف الدائرية، والطبقة الثابتة فوق اليوم المحدّد تُبهت لونه
	.v-tab::before {
		border-radius: inherit;
	}

	.v-tab--active {
		border-color: transparent;

		&::before {
			opacity: 0;
		}

		.v-day-date__number {
			background-color: #fff;
		}
	}

	&__name {
		font-size: 0.6875rem;
		font-weight: 600;
		line-height: 1.4;
		// شفافية لا لون، ليبقى الحرف باهتاً فوق الأبيض وفوق الأخضر معاً
		opacity: 0.75;
	}

	&__number {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 22px;
		height: 22px;
		margin-top: 3px;
		border-radius: 50%;
		background-color: #ededed;
		font-size: 0.8125rem;
		font-weight: 600;
		line-height: 1;
	}
}
</style>